import { AnswerSelectContainerProps }  from '../config';
import { FC } from 'react';
import { IAnswerModel } from '../../../../state/stores/Question/AnswerModel';
import { SnapshotOrInstance } from 'mobx-state-tree';
import { observer } from 'mobx-react';
import { useInitChoiceWithFirstAnswer } from '../useInitChoiceWithFirstAnswer';
import { useStores } from '../../../../hooks/useStores';

const _ContainLanguage: FC<AnswerSelectContainerProps> = ({
  question,
  onPress,
  children,
}) => {
  const { language } = useStores();
  const labels = language?.translate.MOBILE?.ASSISTANCE?.INSTANT_HELP;
  const [initAnswer] = useInitChoiceWithFirstAnswer({
    answers: question.answers as NonNullable<typeof question.answers>,
    questionId: question._id,
    questionKey: question.key,
  });

  const onPressLanguage = (answer: SnapshotOrInstance<IAnswerModel>) => {
    onPress(answer);
  };

  return children({
    answers: question.answers,
    initSelected: initAnswer,
    questionId: question._id,
    questionKey: question.key,
    onPress: onPressLanguage,
    labels: {DROPDOWN: labels?.LANGUAGE}
  });

};

export const ContainLanguage = observer(_ContainLanguage);

